import isEmpty from 'lodash/isEmpty';

import constants from '@/constants';
import canClockShiftEntry from '@/mixins/clocking/individual/canClockShiftEntry';

export default {
  mixins: [canClockShiftEntry],

  methods: {
    createShiftClockIn(
      timePairCustomFieldValues,
      assignmentId,
      timeTypeId,
      successCallBack,
      lastly = () => {
      },
      timeZoneOffset = null,
      locationRequired = false,
      isCloningTimePair = false,
    ) {
      this.getBaseTimeEntryRequest(
        constants.EntryType.CLOCK_IN,
        timeZoneOffset,
        locationRequired,
        assignmentId,
        timeTypeId,
        (timeEntryRequest) => {
          timeEntryRequest.employeeAssignmentId = assignmentId;
          timeEntryRequest.timePairCustomFieldValues = !isEmpty(timePairCustomFieldValues)
            ? timePairCustomFieldValues
            : [];

          this.postShiftTimeEntry(timeEntryRequest, successCallBack, lastly, isCloningTimePair);
        },
        lastly,
      );
    },
  },
};
